import * as React from 'react';
import { Route, Routes } from 'react-router';
import { DocsTopicsPage } from './DocsTopicsPage';
import { DocsArticlePage } from './DocsArticlePage';

export const DocsPage: React.FC = () => {
  return (
    <Routes>
      <Route index element={<DocsArticlePage />} />
      <Route path="topics" element={<DocsTopicsPage />} />
      <Route path="*" element={<DocsArticlePage />} />
    </Routes>
  );
};
